const useImageCheck = ({ onChange, value }) => {
  const handleChange = (id, val) => {
    if (val) {
      onChange([...value, id]);
    } else {
      onChange(value.filter((item) => item !== id));
    }
  };

  return {
    handleChange,
  };
};

export default useImageCheck;
